export const NOTIFICATION_TYPES = `
	query notificationTypes {
		notificationTypes {
			id
            default
            type
		}
    
	}
`;

export const EVENT_NOTIFICATION_PREFERENCES = `
    query eventNotificationPreferences($event_id: Uint) {
        eventNotificationPreferences(event_id: $event_id) {
            event_id
            notification_type_id
            subscribed
        }
    }
`;
